import isEmpty from 'lodash/isEmpty';

import {LOADS, SEARCHLOADS} from './urls';
import {loadsSearch} from '~/modules/loadsSearch/actions';
import {datesWithoutPast} from '~/misc/dates';
import parse from 'date-fns/parse';
import {inputValuesAll} from '~/misc/equipment';
import {coerceQueryTypes} from '~/misc/search';

const legacyDate = /(\d\d)(\d\d)(\d\d)/;

const sortingOptions = ['age', 'dho', 'distance'];
const sortingDefault = 'age';

const dateFromString = (dateString) => {
  if (dateString.length === 6) {
    const nums = dateString.match(legacyDate);
    if (!nums) {
      return null;
    }
    return parse(`20${nums[1]}-${nums[2]}-${nums[3]}`);
  }
  const date = parse(dateString);

  if (isNaN(date)) {
    return null;
  }

  return date;
};

export default (store, history) => {
  history.listen((change) => {
    // if (change.action !== 'POP') {
    //   return;
    // }
    // change.pathname.startsWith(SEARCHLOADS)
    if (change.pathname === LOADS) {
      const query = change.query;

      if (isEmpty(query)) {
        return;
      }
      
      const date = Array.isArray(query.date) ? query.date : query.date && [query.date];
      const equipment = Array.isArray(query.equipment) ? query.equipment : [query.equipment];
      const dots = query.dots && (Array.isArray(query.dots) ? query.dots : [query.dots]);

      setTimeout(() => {
        store.dispatch(
          loadsSearch(
            coerceQueryTypes({
              ...query,
              equipment: equipment.filter(i => inputValuesAll.includes(i)),
              sort_by: sortingOptions.includes(query.sort_by) ? query.sort_by : sortingDefault,
              from_name: query.from_name || '',
              to_name: query.to_name || '',
              date: datesWithoutPast(
                (date || []).map(dateFromString).filter(item => item),
                store.getState().now.date
              ),
              dots: dots,
            })
          )
        );
      }, 0);
    }
  });
};



// WEBPACK FOOTER //
// ./src/routing/recover.js